<template lang="pug">
  div
    template(
      v-if="loaded")
      .list-mobile
        mixer-loads-item-mobile(
        v-for="item in load"
        :key="item.id"
        :item="item")

      v-table-body(
        v-if="loaded"
        outsideTable
        :empty="!load.length")

    template(v-else)
      v-card.mb-3(v-for="i in 5" :key="i")
        .list-mobile.list-mobile--skeleton
          .list-mobile__top
            .list-mobile__title-skeleton
          .list-mobile__content
            .list-mobile__item(v-for="j in 10" :key="`${i}-${j}`")
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1
              .list-mobile__item-skeleton.list-mobile__item-skeleton--type-1

    //- template(
      v-if="loaded && load.length")
      ui-pagination(
        v-model="page"
        offset-none
        :count="totalCount"
        @page-change="loadData")

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import filterMixin from '@/mixins/filter.mixin'

import MixerLoadsItemMobile from './MixerLoadsItemMobile'

import UiPagination from '@/components/ui/ui-pagination/UiPagination'

export default {
  name: 'MixerLoadsListMobile',

  mixins: [filterMixin],

  components: {
    MixerLoadsItemMobile,
    UiPagination
  },

  data: () => ({
    loaded: false
  }),

  computed: {
    ...mapGetters('reports', [
      'load',
      'filters',
      'totalCount'
    ])
  },

  mounted () {
    this.loadData()
  },

  methods: {
    ...mapActions('reports', [
      'getLoad'
    ]),

    async loadData () {
      this.loaded = false
      this.filters.page = this.page > 1 ? this.page : null
      await this.getLoad(this.filters)
      this.loaded = true
    }
  },

  watch: {
    page () {
      this.loaded = false
    }
  }
}
</script>
